import TextField from "../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import TextAreaField from "../../../components/fields/textAreaField/TextAreaField.vue";

import moment from "moment";

import { SnackBarModule } from "../../../modules/SnackBarModule";
import { CassarFeriasService } from "../../../services/CassarFeriasService.js";
import { SolicitarFeriasService } from "../../../services/SolicitarFeriasService.js";

import { TiposFeriasEnum } from "../../../constants";
import { calcularDiasCorridos } from "../../../helper/helper.js";


export default {
  name: "CassarFerias",

  components: {
    TextField,
    PeriodoField,
    SelectField,
    TextAreaField
  },

  props:{
    selected:{
      default: ""
    },
    periodo:{
      default: ""
    },
    numeroDias:{
      default:""
    },
    isOpen: {
      type: Boolean,
      required: true,
    }
  },

  data: () => ({
    form: {},
    justificativaRecusa: null,
    exerciciosOptions: [],
    limiteDias: 25,
    titulo: 'Cassação Férias',

    numeroDiasTitulo: 'Número de dias úteis solicitados',
    numeroDiasCassadoTitulo : 'Número de dias úteis cassados',

    loading: {
      field: false,
      btn: false
    }
  }),

  beforeMount() {
    this.initializeForm();
    this.inicializarModal();
    
  },

  watch: {
    isOpen: function (isOpen) {
      if (isOpen) {
        this.initializeForm();
        this.inicializarModal()
        this.getByIdFerias();
      
      }
    },
    selected: function () {
      this.initializeForm();    
    }
  },


  methods: {
    inicializarModal(){
      if(this.selected.idTipo == TiposFeriasEnum['FERIAS_PREMIO']){
        this.limiteDias = 90
        this.titulo = 'Cassação Férias Prêmio'
        this.numeroDiasTitulo = 'Número de dias corridos solicitados';
        this.numeroDiasCassadoTitulo = 'Número de dias corridos cassados'

      }else{
        this.limiteDias = 25
        this.titulo = 'Cassação Férias'
        this.numeroDiasTitulo = 'Número de dias úteis solicitados';
        this.numeroDiasCassadoTitulo = 'Número de dias úteis cassados'
      }
    },
    async getByIdFerias(){
      const response = await CassarFeriasService.getByIdFerias(this.selected.idFerias);
      this.justificativaRecusa = response.justificativa_recusa;
    },
  
    prepareForm() {

      if (this.$refs.form.validate()) {
        const formData = new FormData();
        formData.append("id_ferias", this.selected.idFerias);
        formData.append("data_ini", moment(this.form.dataCassacaoInicio).format("YYYY-MM-DD"));
        formData.append("data_fim", moment(this.form.dataCassacaoFim).format("YYYY-MM-DD"));
        formData.append("dias", this.form.diasCassacao);
        formData.append("justificativa", this.form.justificativa);
        this.sendForm(formData);
        return;
      }
      SnackBarModule("Preencha os campos corretamente.", "error");
    },

    async calculateDays() {
  
      if (this.form.dataCassacaoInicio) {
        if(this.selected.idTipo != TiposFeriasEnum['FERIAS_PREMIO']){

        const formData = new FormData();
        formData.append("data_ini", moment(this.form.dataCassacaoInicio).format("YYYY-MM-DD"));
        formData.append("dias",this.form.diasCassacao);
        const response =  await SolicitarFeriasService.calcularDiasUteis(formData);
        this.form.dataCassacaoFim = response.dataFim;
        this.form.diasCassacao = response.dias_uteis;

        return true;
        }
        this.form.dataCassacaoFim = calcularDiasCorridos(this.form.dataCassacaoInicio, this.form.diasCassacao)
        return;
      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },
    async sendForm(formData) {
      this.loading.btn = true;
      const response = await CassarFeriasService.postCassarFerias(formData);
      this.loading.btn = false;
      if (response) {
        this.$refs.form.reset();
        this.$emit('on-confirm');
        this.close();
      }
      this.loading.btn = false;
    },

    initializeForm() {
      this.form = {
        dataInicio: this.selected.dataIni,
        dataFim: this.selected.dataFin,
        numeroDias:this.numeroDias,
        dataCassacaoInicio:null,
        dataCassacaoFim:null,
        diasCassacao:null,
        justificativa:""
      }
    },

    close() {
      this.$emit("on-close");
    },
  }
};